//--------------
// has bleeders
//--------------
export default function hasBleeders(combatants) {
  //---------------------------------------
  // where one or more active bleeders exist
  //---------------------------------------
  let bleeders = combatants.some((a) => a.status == 'Active' && a.bleeding > 0)
  return bleeders
}
